import type { CustomField } from '../../groups/types';
import type { TicketTypeSystemFieldsVisibility } from '../../ticket-types';
import { TICKET_SYSTEM_FIELDS } from '../core/types';

interface GetTicketFieldsParams {
	systemFieldsVisibility?: TicketTypeSystemFieldsVisibility;
	customFields?: CustomField[];
}

export type TicketFieldEntry = Partial<Omit<CustomField, 'id' | 'name' | 'kind' | 'allowedComparators'>> &
	Pick<CustomField, 'id' | 'name'> & {
		kind: string;
		allowedComparators?: readonly string[];
		excludeFromFilters?: boolean;
	};

export const getTicketFields = ({
	systemFieldsVisibility,
	customFields = [],
}: GetTicketFieldsParams): TicketFieldEntry[] => {
	const systemFields = systemFieldsVisibility
		? TICKET_SYSTEM_FIELDS.filter((field) => {
				const visibilityKey = field.id as keyof TicketTypeSystemFieldsVisibility;
				if (visibilityKey in systemFieldsVisibility) {
					return systemFieldsVisibility[visibilityKey] !== false;
				}
				return true;
			})
		: TICKET_SYSTEM_FIELDS;

	return [...systemFields, ...customFields.map((field) => ({ ...field, id: `fields.${field.name}` }))];
};
